import React, { useEffect, useRef, useState } from "react";
import SwiperCore, { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { GetBanner } from "../../services/HomeService";

// Import Swiper styles
import "swiper/swiper-bundle.min.css";
import { BodySmall, Heading5 } from "./GlobalElements/Typography";
import { StandardButton } from "./GlobalElements/StandardButton";
SwiperCore.use([Navigation, Pagination]);
const HomeSlider = (props) => {
  const isMounted = useRef(true);
  const [banner, setBanner] = useState([]);


  useEffect(() => {
    isMounted.current = true;
    let domain ;
        if(window.location.hostname.includes("studentportal.devtechnosys.info") || window.location.host.includes("localhost:3000")){
          domain = "aie"
        }else if(window.location.hostname.includes("mygdc.ac") || window.location.host.includes("localhost:3001")){
          domain = "gdc"
        }else if(window.location.hostname.includes("myemendy.ac") || window.location.host.includes("localhost:3001")){
          domain = "emendy"
        }
        
    GetBanner({domain:domain})
      .then((res) => {
        if (isMounted.current) {
        setBanner(res.data);
        }
      })
      .catch(function (err) {
        return false;
      });
    return () => {
      isMounted.current = false;
    };
  }, []);

  const bannerLength = banner.length;
  if (bannerLength === 0) {
    return null;
  }

  return (
    <div className="home-slider-wraper">
      
        <Swiper
          spaceBetween={10}
          slidesPerView={"auto"}
          observer={"true"}
          watchOverflow={"true"}
          onSlideChange={() => {}}
          centeredSlides={false}
          className="swiper-home"
          pagination={{ clickable: true }}
        >
          {bannerLength === 1 && (
            <SwiperSlide
              className="swiper-slide w-100"
              style={{
                backgroundImage: `url('${banner[0].banner_img}')`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                minHeight: "190px",
              }}
            >
              <div className="home-slider-inr">
                <div className="home-slider-content">
                  <Heading5 className="heading">{banner[0].banner_heading}</Heading5>
                  <BodySmall className="text-max-80">{banner[0].banner_subject}</BodySmall>
                  {banner[0].banner_url !== "" ? (
                    <StandardButton 
                      as="a"
                      outline={true}
                      variant="white"
                      href={banner[0].banner_url}
                      target="_blank"
                    >
                      Learn More
                    </StandardButton>
                  ) : null}
                </div>
              </div>
            </SwiperSlide>
          )}
          {bannerLength === 2 && (
            <React.Fragment>
              <SwiperSlide
                className="swiper-slide w-50"
                style={{
                  backgroundImage: `url('${banner[0].banner_img}')`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  minHeight: "190px",
                }}
              >
                <div className="home-slider-inr">
                  <div className="home-slider-content">
                    <Heading5 className="heading">{banner[0].banner_heading}</Heading5>
                    <BodySmall className="text-max-80">{banner[0].banner_subject}</BodySmall>
                    {banner[0].banner_url !== "" ? (
                     <StandardButton
                        as="a"
                        outline={true}
                        variant="white"
                        href={banner[0].banner_url}
                        target="_blank"
                      >
                        Learn More
                      </StandardButton>
                    ) : null}
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide
                className="swiper-slide w-50"
                style={{
                  backgroundImage: `url('${banner[1].banner_img}')`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  minHeight: "190px",
                }}
              >
                <div className="home-slider-inr">
                  <div className="home-slider-content">
                    <Heading5 className="heading">{banner[1].banner_heading}</Heading5>
                    <BodySmall>{banner[1].banner_subject}</BodySmall>
                    {banner[1].banner_url !== "" ? (
                     <StandardButton
                        as="a"
                        outline={true}
                        variant="white"
                        href={banner[1].banner_url}
                        target="_blank"
                      >
                        Learn More
                      </StandardButton>
                    ) : null}
                  </div>
                </div>
              </SwiperSlide>
            </React.Fragment>
          )}
          {bannerLength === 3 && (
            <React.Fragment>
              <SwiperSlide
                className="swiper-slide w-50"
                style={{
                  backgroundImage: `url('${banner[0].banner_img}')`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  minHeight: "190px",
                }}
              >
                <div className="home-slider-inr">
                  <div className="home-slider-content">
                    <Heading5 className="heading">{banner[0].banner_heading}</Heading5>
                    <BodySmall className="text-max-80">{banner[0].banner_subject}</BodySmall>
                    {banner[0].banner_url !== "" ? (
                     <StandardButton
                        as="a"
                        outline={true}
                        variant="white"
                        href={banner[0].banner_url}
                        target="_blank"
                      >
                        Learn More
                      </StandardButton>
                    ) : null}
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide
                className="swiper-slide w-25"
                style={{
                  backgroundImage: `url('${banner[1].banner_img}')`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  minHeight: "190px",
                }}
              >
                <div className="home-slider-inr">
                  <div className="home-slider-content">
                    <Heading5 className="heading">{banner[1].banner_heading}</Heading5>
                    <BodySmall>{banner[1].banner_subject}</BodySmall>
                    {banner[1].banner_url !== "" ? (
                     <StandardButton
                        as="a"
                        outline={true}
                        variant="white"
                        href={banner[1].banner_url}
                        target="_blank"
                      >
                        Learn More
                      </StandardButton>
                    ) : null}
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide
                className="swiper-slide w-25"
                style={{
                  backgroundImage: `url('${banner[2].banner_img}')`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  minHeight: "190px",
                }}
              >
                <div className="home-slider-inr">
                  <div className="home-slider-content">
                    <Heading5 className="heading">{banner[2].banner_heading}</Heading5>
                    <BodySmall>{banner[2].banner_subject}</BodySmall>
                    {banner[2].banner_url !== "" ? (
                      <StandardButton
                        as="a"
                        outline={true}
                        variant="white"
                        href={banner[2].banner_url}
                        target="_blank"
                      >
                        Learn More
                      </StandardButton>
                    ) : null}
                  </div>
                </div>
              </SwiperSlide>
            </React.Fragment>
          )}
          {bannerLength === 4 && (
            <React.Fragment>
              <SwiperSlide
                className="swiper-slide w-50"
                style={{
                  backgroundImage: `url('${banner[0].banner_img}')`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  minHeight: "190px",
                }}
              >
                <div className="home-slider-inr">
                  <div className="home-slider-content">
                    <Heading5 className="heading">{banner[0].banner_heading}</Heading5>
                    <BodySmall className="text-max-80">{banner[0].banner_subject}</BodySmall>
                    {banner[0].banner_url !== "" ? (
                      <StandardButton
                        as="a"
                        outline={true}
                        variant="white"
                        href={banner[0].banner_url}
                        target="_blank"
                      >
                        Learn More
                      </StandardButton>
                    ) : null}
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide
                className="swiper-slide w-25"
                style={{
                  backgroundImage: `url('${banner[1].banner_img}')`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  minHeight: "190px",
                }}
              >
                <div className="home-slider-inr">
                  <div className="home-slider-content">
                    <Heading5 className="heading">{banner[1].banner_heading}</Heading5>
                    <BodySmall>{banner[1].banner_subject}</BodySmall>
                    {banner[1].banner_url !== "" ? (
                      <StandardButton
                        outline={true}
                        as="a"
                        variant="white"
                        href={banner[1].banner_url}
                        target="_blank"
                      >
                        Learn More
                      </StandardButton>
                    ) : null}
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide
                className="swiper-slide w-25"
                style={{
                  backgroundImage: `url('${banner[2].banner_img}')`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  minHeight: "190px",
                }}
              >
                <div className="home-slider-inr">
                  <div className="home-slider-content">
                    <Heading5 className="heading">{banner[2].banner_heading}</Heading5>
                    <BodySmall>{banner[2].banner_subject}</BodySmall>
                    {banner[2].banner_url !== "" ? (
                      <StandardButton
                        outline={true}
                        as="a"
                        variant="white"
                        href={banner[2].banner_url}
                        target="_blank"
                      >
                        Learn More
                      </StandardButton>
                    ) : null}
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide
                className="swiper-slide w-50"
                style={{
                  backgroundImage: `url('${banner[3].banner_img}')`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  minHeight: "190px",
                }}
              >
                <div className="home-slider-inr">
                  <div className="home-slider-content">
                    <Heading5 className="heading">{banner[3].banner_heading}</Heading5>
                    <BodySmall className="text-max-80">{banner[3].banner_subject}</BodySmall>
                    {banner[3].banner_url !== "" ? (
                      <StandardButton
                        outline={true}
                        as="a"
                        variant="white"
                        href={banner[3].banner_url}
                        target="_blank"
                      >
                        Learn More
                      </StandardButton>
                    ) : null}
                  </div>
                </div>
              </SwiperSlide>
            </React.Fragment>
          )}
        </Swiper>
      
    </div>
  );
};

export default HomeSlider;
